import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import OverlaysWrapper from './OverlaysWrapper';
import SubsDetail from './SubsDetail';
import SubsList from './list';
import { useGlobalContext } from './state/GlobalContext';
import { Login } from './login';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchInterval: false,
    },
  },
});

export default (): React.ReactElement => {
  const { subscriptionId, customerId, shopDomain } = useGlobalContext();

  return (
    <div id="bundle-app">
      {customerId ? (
        <QueryClientProvider client={queryClient}>
          <OverlaysWrapper>
            {subscriptionId ? <SubsDetail /> : <SubsList />}
          </OverlaysWrapper>
        </QueryClientProvider>
      ) : (
        <Login shopDomain={shopDomain || ''} />
      )}
    </div>
  );
};
